import React from "react";

// Helper to get nested values, e.g., "chain.name"
const getNestedValue = (obj, path) =>
  path.split('.').reduce((acc, part) => acc && acc[part], obj);

const TableRow = ({ item, fields, rowClassName }) => {
  // Example: rowClassName can be a function: (item) => item.status === 'review' ? 'bg-yellow-50' : ''
  const trClass = typeof rowClassName === 'function' ? rowClassName(item) : rowClassName || '';

  return (
    <tr className={trClass}>
      {fields.map((field, idx) => {
        const {
          key,                // unique key for React
          name,               // property path (e.g. "chain.name")
          render,             // optional render function
          className = "whitespace-nowrap px-6 py-4 text-sm text-gray-900"
        } = field;

        let value = getNestedValue(item, name);

        // Special handling for render function
        if (render) {
          value = render(item);
        }

        return (
          <td className={className} key={key || name || idx}>
            {value}
          </td>
        );
      })}
    </tr>
  );
};

export default TableRow;